<template>
  <div>
    <b-navbar toggleable="lg" type="light" variant="light" fixed="top">
      <b-navbar-brand href="#">
        <img src="@/assets/images/chr-logo.png" alt="christian tour logo" class="logo-img">
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <navMenu></navMenu>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto d-flex align-items-end">
          <userData/>
          <secondaryMenu/>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import navMenu from './main_menu'
import secondaryMenu from './secondary_menu'
import userData from './user_data'
export default {
  name: 'Menu',
  components: { navMenu, secondaryMenu, userData }
}
</script>

<style lang="scss" scoped>

</style>
